import { render, staticRenderFns } from "./WizardTriageStep.vue?vue&type=template&id=df01f6ee&scoped=true"
import script from "./WizardTriageStep.vue?vue&type=script&lang=js"
export * from "./WizardTriageStep.vue?vue&type=script&lang=js"
import style0 from "./WizardTriageStep.vue?vue&type=style&index=0&id=df01f6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df01f6ee",
  null
  
)

export default component.exports